// Stockists store list tabs - sections/stockists-store-list.liquid
// Toggles which pre-rendered panel (All / Jewelry / Salt) is visible, entirely client-side.
class StockistsStoreTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll("[data-stockists-tab]"));
    this.panels = Array.from(this.querySelectorAll("[data-stockists-panel]"));
    this.tabs.forEach((tab) => tab.addEventListener("click", () => this.selectTab(tab)));
  }

  selectTab(tab) {
    const key = tab.getAttribute("data-stockists-tab");

    this.tabs.forEach((otherTab) => {
      const isActive = otherTab === tab;
      otherTab.classList.toggle("is-active", isActive);
      otherTab.setAttribute("aria-selected", isActive);
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle("hidden", panel.getAttribute("data-stockists-panel") !== key);
    });
  }
}

if (!window.customElements.get("stockists-store-tabs")) {
  window.customElements.define("stockists-store-tabs", StockistsStoreTabs);
}
